// extracted by mini-css-extract-plugin
export default {"root":"_11sw18TV","img":"_1p_JrHZP","title":"_9AwEj8Rn","description":"_3OjsScVA"};